import React, { useState, useEffect } from "react";
import { useHistory, Redirect } from "react-router-dom";
import "./AdvisorProfile.scss";
import { useDispatch, useSelector } from "react-redux";
import { GetStripeSubscriptions } from "../../Apis/GetStripeSubscriptions";
import { CancelStripeSubscription } from "../../Apis/CancelStripeSubscription";
import { ModifyUserSubscription } from "../../Apis/ModifyUserSubscription";
import {
  handleApiError,
  showConfirmNotification,
  showNotification,
} from "../../actions/notificationActions";
import UpdateProfile from "../UpdateAdvisorProfile/UpdateAdvisorProfile";
import { openDrawer } from "../../actions/drawerActions";
import { fetchProfile } from "../../actions/advisorProfileActions";
import { updateUserSubscriptionData } from "../../actions/userSubscriptionActions";
import { CreateCustomerPortalSession } from "../../Apis/CreateCustomerPortalSession";
import Toaster from "../Toaster/Toaster";
import TagManager from "react-gtm-module";
import Avatar from "@mui/material/Avatar";
import SkeletonComponent from '../Skeleton/Skeleton';

function AdvisorProfile() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [subscriptions, setSubscriptions] = useState([]); 
  const [activePlan, setActivePlan] = useState(null);
  const advisorProfile = useSelector(
    (state) => state.advisorProfile.profileData
  );

  const [showUpdateProfile, setShowUpdateProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleLogOut = () => history.push("/");
  const activeDrawer =
    useSelector((state) => state.drawer.activeDrawer) === "EditProfile";
  const profileImage =
    useSelector(
      (state) => state.userPicture.userPictureData?.profile_picture
    ) || null;
  const subscriptionsDetails =
    useSelector((state) => state.userSubscription.subscriptionData) || {};
  const { user_type: userType, customer_id: CustomerID } = subscriptionsDetails;
 const isAdminFlag = subscriptionsDetails.advisor_admin === true
  ? true
  : subscriptionsDetails.subscription_plan_type === 'Adaptive Advisor Firm Plan'
    ? false
    : true;

  const whiteListCustomerFlag = (subscriptionsDetails.subscription_plan_type === 'Whitelist Customer Plan' || !isAdminFlag);

  const subscriptionPlanNames = [
    { usertype:'Investor', plan_terms:'' , signup_url:'investorsignup', btn_text: 'Start 1 Month - Free Trial', stripe_interval:'month', stripe_name: 'Adaptive Investor Core Plan', screen_name: 'Investor', icon:'SELF', price:'$25', price_desc:'/ Per Month', features: [
        {'feature': 'Adaptive IntelligenceTM Portfolio Analytics with options', 'class': ''},
        {'feature': 'Market ShieldTM for Downside Protection', 'class': ''},
        {'feature': 'Call Writing for Income', 'class': ''},
        {'feature': 'Upload Portfolio', 'class': ''},
        {'feature': 'Up to 3 Portfolios of Maximum 15 Tickers', 'class': ''},
        {'feature': 'Market Quotes (15 min delayed)', 'class': ''},
        {'feature': 'Download Options Trades', 'class': ''},
        {'feature': 'Option IntelligenceTM Monthly Report', 'class': 'close'},
        {'feature': 'Link to Brokerage Platforms', 'class': 'close'}
        ]
    },

    { usertype:'Investor', plan_terms:'' , signup_url:'investorsignup', btn_text: 'Start 1 Month - Free Trial',  stripe_interval:'year', stripe_name: 'Adaptive Investor Core Plan', screen_name: 'Investor', icon:'SELF', price:'$250', price_desc:'/ Per Year', features: [
        {'feature': 'Adaptive IntelligenceTM Portfolio Analytics with options', 'class': ''},
        {'feature': 'Market ShieldTM for Downside Protection', 'class': ''},
        {'feature': 'Call Writing for Income', 'class': ''},
        {'feature': 'Upload Portfolio', 'class': ''},
        {'feature': 'Up to 3 Portfolios of Maximum 15 Tickers', 'class': ''},
        {'feature': 'Market Quotes (15 min delayed)', 'class': ''},
        {'feature': 'Download Options Trades', 'class': ''},
        {'feature': 'Option IntelligenceTM Monthly Report', 'class': 'close'},
        {'feature': 'Link to Brokerage Platforms', 'class': 'close'}
        ]
    },

    { usertype:'Advisor', plan_terms:'' , signup_url:'advisorsignup', btn_text: 'Start 1 Month - Free Trial', stripe_interval: 'month', stripe_name: 'Adaptive Standard Plan', screen_name: 'Advisor', icon:'AdvisorPlan' ,price:'$65', price_desc: '/ Per Month', features: [
        {'feature': 'Adaptive IntelligenceTM Portfolio Analytics with options', 'class': ''},
        {'feature': 'Market ShieldTM for Downside Protection', 'class': ''},
        {'feature': 'Call Writing for Income', 'class': ''},
        {'feature': 'Upload Portfolio', 'class': ''},
        {'feature': 'Up to 10 Portfolios of Maximum 50 Tickers', 'class': ''},
        {'feature': 'Market Quotes (15 min delayed)', 'class': ''},
        {'feature': 'Download Options Trades', 'class': ''},
        {'feature': 'Option IntelligenceTM Monthly Report', 'class': 'close'},
        {'feature': 'Link to Brokerage Platforms', 'class': 'close'}
        ]
    },

    { usertype:'Advisor', plan_terms:'' , signup_url:'advisorsignup', btn_text: 'Start 1 Month - Free Trial', stripe_interval:'year', stripe_name: 'Adaptive Standard Plan', screen_name: 'Advisor', icon:'AdvisorPlan' ,price:'$650', price_desc: '/ Per Year', features: [
        {'feature': 'Adaptive IntelligenceTM Portfolio Analytics with options', 'class': ''},
        {'feature': 'Market ShieldTM for Downside Protection', 'class': ''},
        {'feature': 'Call Writing for Income', 'class': ''},
        {'feature': 'Upload Portfolio', 'class': ''},
        {'feature': 'Up to 10 Portfolios of Maximum 50 Tickers', 'class': ''},
        {'feature': 'Market Quotes (15 min delayed)', 'class': ''},
        {'feature': 'Download Options Trades', 'class': ''},
        {'feature': 'Option IntelligenceTM Monthly Report', 'class': 'close'},
        {'feature': 'Link to Brokerage Platforms', 'class': 'close'}
        ]
    },

    { usertype:'Advisor', plan_terms:'* Minimum 3-Month Contract' , btn_text: 'Unlock 85% Off - Subscribe Now' ,signup_url:'advisorsignup', stripe_interval: 'month', stripe_name: 'Adaptive Advisor Firm Plan', screen_name: 'Advisor Firm',icon:'AdvisorPro',price:'$500', price_desc:'/ Per Month', features: [
        {'feature': 'Adaptive IntelligenceTM Portfolio Analytics with options', 'class': ''},
        {'feature': 'Market ShieldTM for Downside Protection', 'class': ''},
        {'feature': 'Call Writing for Income', 'class': ''},
        {'feature': 'Upload Portfolio', 'class': ''},
        {'feature': 'Unlimited Portfolios and Tickers', 'class': ''},
        {'feature': 'Market Quotes (Real Time - 15 min delayed during discount period)', 'class': ''},
        {'feature': 'Download Options Trades With Indicative Limit Prices.', 'class': ''},
        {'feature': 'Option IntelligenceTM Monthly Report', 'class': ''},
        {'feature': 'Customized Link to Third Party Platforms Available (at Extra Cost) Contact Us at: hello@adaptive-investments.com', 'class': ''}
        ]
    },

    { usertype:'Advisor', plan_terms:'* Minimum 3-Month Contract' , btn_text: 'Unlock 85% Off - Subscribe Now', signup_url:'advisorsignup', stripe_interval: 'year', stripe_name: 'Adaptive Advisor Firm Plan', screen_name: 'Advisor Firm',icon:'AdvisorPro',price:'$5000', price_desc:'/ Per Year', features:[
        {'feature': 'Adaptive IntelligenceTM Portfolio Analytics with options', 'class': ''},
        {'feature': 'Market ShieldTM for Downside Protection', 'class': ''},
        {'feature': 'Call Writing for Income', 'class': ''},
        {'feature': 'Upload Portfolio', 'class': ''},
        {'feature': 'Unlimited Portfolios and Tickers', 'class': ''},
        {'feature': 'Market Quotes (Real Time - 15 min delayed during discount period)', 'class': ''},
        {'feature': 'Download Options Trades With Indicative Limit Prices.', 'class': ''},
        {'feature': 'Option IntelligenceTM Monthly Report', 'class': ''},
        {'feature': 'Customized Link to Third Party Platforms Available (at Extra Cost) Contact Us at: hello@adaptive-investments.com', 'class': ''}
        ]
    },
  ]

  const [showAlmostThere, setShowAlmostThere] = useState(false);
    React.useEffect(() => {
        let timer;
        if (isLoading) {
            timer = setTimeout(() => {setShowAlmostThere(true);}, 1750);
        } else {
            setShowAlmostThere(false);
        }
        return () => clearTimeout(timer);
    }, [isLoading]);

  const [monthlySubscriptionFlag, setMonthlySubscriptionFlag] = useState(
    subscriptionsDetails.subscription_interval === 'month' ? false : true
  );

  const [subscriptionInterval, setSubscriptionInterval] = useState(subscriptionsDetails.subscription_interval);

  useEffect(() => {
    setSubscriptionInterval(monthlySubscriptionFlag ? 'year' : 'month');
  },[monthlySubscriptionFlag])

  useEffect(() => {
    setIsLoading(true);
    fetchSubscriptions();
    if (Object.keys(advisorProfile).length === 0) {
      dispatch(fetchProfile()).then(() => {
        setIsLoading(false);
      });
    }
  }, [dispatch, advisorProfile]);

  const fetchSubscriptions = () => {
    GetStripeSubscriptions().then((subscriptionsResponse) => {
      setIsLoading(false);
      if (subscriptionsResponse.status === 200) {
        setSubscriptions(subscriptionsResponse.result);
        setActivePlan(
          Object.keys(subscriptionsResponse).length > 0
            ? subscriptionsResponse.result
            : null
        );
        dispatch(updateUserSubscriptionData(subscriptionsResponse.result.stripe_plan_details));
      } else {
        handleApiError(subscriptionsResponse, dispatch);
      }
    });
  };

  const handleCancelSubscription = (subscriptionId) => {
    dispatch(
      showConfirmNotification(
        "Are you sure you want to cancel your subscription plan?",
        () => cancelSubscription(subscriptionId)
      )
    );
  };

  const SubmitModifySubscription = (plan_name, plan_interval) => {
    setIsLoading(true);
    ModifyUserSubscription(plan_name, plan_interval).then((response) => {
        if (response.status === 200) {
            setActivePlan({'plan_amount': response.result.plan_amount,'current_period_end': response.result.current_period_end})
            dispatch(updateUserSubscriptionData(response.result))
            requestAnimationFrame(() => {
              dispatch(showNotification("Subscription Plan Modified Successfully. Click on the link to go back to portfolio dashboard. ","success","popup","/ClientPortfolios"))
              setIsLoading(false);
            });
        } else {
            handleApiError(response, dispatch);
            setIsLoading(false);
        }
    });
  };

  const cancelSubscription = (subscriptionId) => {
    setIsLoading(true);
    CancelStripeSubscription().then((response) => {
      setIsLoading(false);
      if (response.status === 200) {
        TagManager.dataLayer({
          dataLayer: {
            event: "Subscription Cancelled",
            userType: userType,
            user_id: CustomerID,
          },
        });
        dispatch(updateUserSubscriptionData(response.result));
        dispatch(
          showNotification(
            "Subscription Cancelled Successfully",
            "success",
            "toaster"
          )
        );
        history.push({ pathname: "/OnboardScreen", state: { stage: 2 } });
        console.log(`Subscription ${subscriptionId} cancelled`);
      } else {
        handleApiError(response, dispatch);
      }
    });
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString("en-US");
  };

  const isSubscriptionActive = (subscription) => {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return subscription.current_period_end > currentTimestamp;
  };

  const toggleUpdateProfile = () => {
    dispatch(
      openDrawer("EditProfile", {
        firstName: advisorProfile.firstname,
        lastName: advisorProfile.lastname,
        emailid: advisorProfile.emailid,
        companyname: advisorProfile.companyname,
        crd_number: advisorProfile.crd_number,
        contactno: advisorProfile.contactno,
      })
    );
    setShowUpdateProfile(!showUpdateProfile);
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName ? firstName[0].toUpperCase() : ""}${
      lastName ? lastName[0].toUpperCase() : ""
    }`;
  };

  if (isLoading) {
    return (
      <div className="loading-overlay">
        <SkeletonComponent variant="profile" showAlmostThere={showAlmostThere} />
      </div>
    );
  }

  if (
    subscriptionsDetails.subscription_status !== "active" &&
    subscriptionsDetails.subscription_plan_type === "No Active Plan"
  ) {
    return (
      <Redirect to={{ pathname: "/OnboardScreen", state: { stage: 2 } }} />
    );
  }

  const getSubscriptionMessage = (subscriptionsDetails, plan_name, plan_interval) => {
    const downgradeMessage = "Upon downgrade, all portfolios will be archived for 30 days. You may select up to 10 portfolios to keep active. Each active portfolio can have up to 100 tickers. After 30 days, all non-selected (archived) portfolios will be permanently removed from your access. Do you wish to continue?";
    const upgradeMessage = "Are you sure you wish to upgrade your Subscription?";
    const monthToAnual = "Are you sure you wish to update your billing period from month to year?";
    const anualToMonth = "Are you sure you wish to update your billing period from year to month?";
    
    if (subscriptionsDetails.subscription_plan_type === 'Adaptive Advisor Firm Plan') {
      if (plan_name === 'Adaptive Advisor Firm Plan'){
          if(subscriptionsDetails.subscription_interval === 'month' && plan_interval === 'year') {
            return monthToAnual;
          } else {
            return anualToMonth;
          } 
      } else if(plan_name === 'Adaptive Standard Plan'){
        return downgradeMessage;
        
      }
    }
    
    if (subscriptionsDetails.subscription_plan_type === 'Adaptive Standard Plan') {
      if (plan_name === 'Adaptive Standard Plan'){
        if(subscriptionsDetails.subscription_interval === 'month' && plan_interval === 'year'){
          return monthToAnual;
        } else {
          return anualToMonth;
        }
      }
      else if (plan_name === 'Adaptive Advisor Firm Plan'){
        return upgradeMessage;
      }
    }
    if(subscriptionsDetails.subscription_plan_type === "Adaptive Investor Core Plan"){
      if (plan_name === 'Adaptive Investor Core Plan'){
        if(subscriptionsDetails.subscription_interval === 'month' && plan_interval === 'year'){
          return monthToAnual;
        } else {
          return anualToMonth;
        }
      }
    }
    return '';
  }

  const handleSubscriptionUpgrade = (plan_name,plan_interval) => {
    let message = getSubscriptionMessage(subscriptionsDetails, plan_name, plan_interval);
    dispatch(
      showConfirmNotification(
        message,
        () => SubmitModifySubscription(plan_name,plan_interval)
      )
    );
  };

  const handleCustomerPortalSession = () => {
    setIsLoading(true);
    CreateCustomerPortalSession(window.location.href).then((response) => {
      if (response) {
        setIsLoading(false);
        TagManager.dataLayer({
          dataLayer: {
          event: "Used Customer Portal",
          userType: userType,
          user_id: CustomerID,
          },
      });
        document.body.classList.add('fade-out');
        requestAnimationFrame(() => {
          window.location.href = response;
        });

      } else {
        handleApiError(response, dispatch);
      }
    })
  };
  
  return (
    <>
      <div className="profiledata">
        <div className="toast-container">
          <Toaster />
        </div>
        <div className="advisorcard">
          <a className="user-info">
            <span className="user-avatar">
              {profileImage ? (
                <Avatar
                  alt="User Avatar"
                  src={profileImage}
                  sx={{ width: 80, height: 80 }}
                />
              ) : (
                getInitials(advisorProfile.firstname, advisorProfile.lastname)
              )}
            </span>
          </a>
          <div className="username">
            <h4>
              {advisorProfile.firstname} {advisorProfile.lastname}
            </h4>
            <div className="designations">
              <a>
                <img src="./Assets/Mail.svg" alt="Email" />{" "}
                <span>{advisorProfile.emailid}</span>
              </a>
              <a>
                <img src="./Assets/Firm.svg" alt="Company" />{" "}
                <span>{advisorProfile.companyname}</span>
              </a>
              <a>
                <span>Contact Number: {advisorProfile.contactno}</span>
              </a>
              <a>
                <span>CRD Number: {advisorProfile.crd_number}</span>
              </a>
            </div>
          </div>
        </div>
        <div className="profileaction">
          <button  className={`ai-btn primary solid ${whiteListCustomerFlag ? 'disabled' : ''}`} disabled={whiteListCustomerFlag} onClick={handleCustomerPortalSession}><img src="./Assets/Creditcard.svg" />Manage Payments</button>
          <button className="ai-btn blue solid" onClick={toggleUpdateProfile}>
            <img src="./Assets/EditUser.svg" />
            Edit Profile
          </button>
        </div>
      </div>
      <div className="profileoption">
        {activePlan && subscriptionsDetails.subscription_status === "active" ? (
        <>
          <div className="plan">
            <div className="planhead">
                <h3>Active Plan</h3>
            </div>
            <div className="planinfo">
              <div className="point">
                <div>{advisorProfile.emailid}</div>
              </div>
              {!whiteListCustomerFlag && (
                <>
                  <div className="point">
                    Auto-renewed On - {formatDate(activePlan.current_period_end)}
                  </div>
                  <div className="point">Amount - ${(activePlan.plan_amount / 100).toFixed(2)}</div>
                </>
              )}
              <div className="point">
                Plan Type - {subscriptionsDetails.subscription_plan_type}
              </div>
              <div className="point">
                Portfolio Limit -{" "}
                {subscriptionsDetails.subscription_plan_active_portfolio_limit !== 'Infinity' ? subscriptionsDetails.subscription_plan_active_portfolio_limit: 'Unlimited'}
              </div>
              <div className="point">
                Portfolio Line Items Limit -{" "}
                {
                  subscriptionsDetails.subscription_plan_active_portfolio_line_items_limit !== 'Infinity' ? subscriptionsDetails.subscription_plan_active_portfolio_line_items_limit: 'Unlimited'
                }
              </div>
            </div>
            <div className="cancelsub">
            {isSubscriptionActive(activePlan) && (
              <button
                  className={`ai-btn red solid ${whiteListCustomerFlag ? 'disabled' : ''}`}
                  disabled={whiteListCustomerFlag}
                  onClick={() => handleCancelSubscription(activePlan.id)}
              >
                  Cancel Subscription
              </button>
            )}
          </div>
            {/* <button className='ai-btn primary solid'>Renew Now</button> */}
          </div>
          <div className='switcher'>
            <span>{'Monthly'}</span>
            <div className="toggle-switch">
              <input
                type="checkbox"
                id="mode-toggle"
                checked={monthlySubscriptionFlag}
                onChange={() => setMonthlySubscriptionFlag(!monthlySubscriptionFlag)}
              />
              <label htmlFor="mode-toggle" className="toggle-label"></label>
            </div>
            <span>Annualy</span>
          </div>
          
          <div className="ShieldCardcon pricing-card">
            {subscriptionPlanNames
              .filter(plan => plan.usertype === subscriptionsDetails.user_type && plan.stripe_interval === subscriptionInterval)
              .map(plan => (
                <div className="pricecardshield" key={plan.stripe_name}>
                  {subscriptionsDetails.subscription_plan_type === plan.stripe_name &&  plan.stripe_interval === subscriptionsDetails.subscription_interval && (
                    <div className="popular-tag">
                      <span>Active Subscription</span>
                    </div>
                  )}
                  <div className="card-content-investor">
                    <div className="top-heading-in">
                      <div className="in-icon">
                        <img
                          src={`./Assets/${plan.icon}.svg`}
                          alt={`${plan.screen_name} icon`}
                          role="img"
                          width={30}
                          height={30}
                        />
                      </div>
                      <h3>{plan.screen_name}</h3>
                    </div>
                    <div className="price-listing">
                      <div className="price-top">
                        <p className="price-number">{plan.price}</p>
                      </div>
                      <div className="price-btm">
                        <p>{plan.price_desc}</p>
                      </div>
                    </div>
                    {(subscriptionsDetails.subscription_plan_type !== plan.stripe_name || subscriptionsDetails.subscription_interval !== plan.stripe_interval) && (
                      <a
                        className={`button card-btn ${whiteListCustomerFlag ? 'disabled' : ''}`}
                        onClick={whiteListCustomerFlag ? (e) => e.preventDefault() : () => handleSubscriptionUpgrade(plan.stripe_name, plan.stripe_interval)}
                      >
                        {(subscriptionsDetails.subscription_plan_type === 'Adaptive Advisor Firm Plan' && subscriptionsDetails.subscription_interval === subscriptionInterval )? 'Buy Plan' : 'Buy Plan'}
                      </a>
                    )}
                  </div>
                  <div className="marking-list">
                    <ul>
                      {plan.features.map((feature, index) => (
                          <li key={index}>
                              <img className="" src={feature.class !== 'close'? './Assets/checklist.svg' : './Assets/close_icon.svg'}/>
                              <span dangerouslySetInnerHTML={{ __html: feature.feature }}></span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              ))}
          </div>

        </>
        ) : (
          <p>No active subscription found.</p>
        )}
        {/* <div className='history'>
                    <h4>View Purchase history </h4>
                    <button className='ai-link'>View Purchase history</button>
                </div> */}
        {/* <span className='divider'></span> */}
        {/* <div className='history'>
                    <div className='closeacc'><h4>Closing your account </h4><span>Once you delete your account, there is no going back. Please be certain.</span></div>
                    <button className='ai-btn red solid'>Delete Account</button>
                </div> */}
      </div>
      {activeDrawer && <UpdateProfile />}
    </>
  );
}

export default AdvisorProfile;
